import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {Form, Modal, Button, Input} from "antd";
import RegularExpression from "../../../constants/RegularExpression";
import {changePassword} from "../../../actions/AccountActions";


class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        }
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('NewPassword')) {
            callback(this.props.intl.messages.inconsistent_passwords);
        } else {
            callback();
        }
    };

    handleSubmit = (form, props) => {

        //Validate completed data
        form.validateFields((err, values) => {
            if (!err) {
                values.Email = this.props.email;

                this.props.dispatch(changePassword(values, props.history, this.props.intl)).then((status) => {

                    if(status !== 'error') {
                        this.handleCancel()
                    }
                    props.form.resetFields();
                });
            }
        });
    };

    render() {

        const { getFieldDecorator } = this.props.form;

        return (
            <React.Fragment>
                <a onClick={this.showModal}>{this.props.intl.messages.change_password}</a>

                {/* Change Password Modal */}
                <Modal
                    title={this.props.intl.messages.change_password}
                    visible={this.state.visible}
                    centered
                    onCancel={this.handleCancel}

                    footer={[
                        <React.Fragment>
                            <Button onClick={this.handleCancel}
                                    key="next">{this.props.intl.messages.cancel}</Button>
                            <Button onClick={this.handleSubmit.bind(this, this.props.form, this.props, this.state)} key="save"
                                    type="primary">{this.props.intl.messages.save}</Button>
                        </React.Fragment>
                    ]}
                >
                    <Form>
                        <Form.Item label={this.props.intl.messages.current_password}>
                            {getFieldDecorator('CurrentPassword', {
                                rules: [{
                                    pattern: RegularExpression.PASSWORD_VALIDATION,
                                    message: this.props.intl.messages.invalid_password
                                },
                                ],
                            })(
                                <Input type="password" autoComplete="off" maxLength={50} />
                            )}
                        </Form.Item>
                        <Form.Item label={this.props.intl.messages.new_password}>
                            {getFieldDecorator('NewPassword', {
                                rules: [{
                                    pattern: RegularExpression.PASSWORD_VALIDATION,
                                    message: this.props.intl.messages.invalid_password
                                },
                                ],
                            })(
                                <Input type="password" autoComplete="off" maxLength={50} />
                            )}
                        </Form.Item>
                        <Form.Item label={this.props.intl.messages.confirm_new_password}>
                            {getFieldDecorator('ConfirmPassword', {
                                rules: [{
                                    validator: this.compareToFirstPassword,
                                },
                                ],
                            })(
                                <Input type="password" autoComplete="off" maxLength={50} />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        account: state.account
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
};

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(ChangePassword)));


// WEBPACK FOOTER //
// ./src/routes/subAffilate/Account/ChangePassword.js